module.exports = __webpack_public_path__ + "static/img/award.448b220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/award.png
// module id = 6o4s
// module chunks = 0